import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

var _types$SET_CURRENT_RO;

import * as types from './types';
export default (_types$SET_CURRENT_RO = {}, _defineProperty(_types$SET_CURRENT_RO, types.SET_CURRENT_ROUTE, function (state, payload) {
  var currentState = state;
  currentState.currentRoute = payload;
}), _defineProperty(_types$SET_CURRENT_RO, types.SET_PREVIOUS_ROUTE, function (state, payload) {
  var currentState = state;
  currentState.previousRoute = payload;
}), _types$SET_CURRENT_RO);